import React, { Component } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip"

class NewsPage extends Component {

  componentDidMount(){
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="Tetley's become Leeds Metropolitan University's transport supplier" description="Tetley's Coaches becomes one of only four coach operators on the Leeds Metropolitan University's (now Leeds Beckett University) transport supplier framework agreement following a comprehensive tender process." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article" style={{ background: 'white' }}>
            <div>
              <h1 className="page-content-heading">Tetley's become Leeds Metropolitan University's transport supplier</h1>
              <p className="news-article-date">November 2013</p>
            </div>

            <div className="news-article-body">
              <p>Tetley's Coaches becomes one of only four coach operators on the Leeds Metropolitan University's (now Leeds Beckett University) transport supplier framework agreement following a comprehensive tender process.</p>
              <p>We provide staff, student and visitor transport for numerous events including open days, sporting events and educational visits.</p>
            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default NewsPage
